<template>
    <form @submit.prevent="onTest(data)" class="card">
        <div class="card-body">
            <h5 class="card-title fw-semibold mb-4">Test de correo electrónico</h5>
            <div class="form-group mb-3">
                <label>Correo electrónico : <span class="text-danger">*</span></label>
                <input type="text" class="form-control" name="test_email" v-model="data.test_email"
                    placeholder="test_email">
            </div>
        </div>
        <div class="card-footer">
            <button type="submit" class="btn btn-success rounded-pill px-4">
                <span v-if="count > 0" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span :class="{ 'visually-hidden': count > 0 }">
                    <i class="ti ti-device-floppy me-1 fs-4"></i> Enviar correo
                </span>
            </button>
        </div>
    </form>
</template>
<script>
export default {
  data () {
    return {
      data: {},
      count: 0
    }
  },
  methods: {
    onTest: function (data) {
      this.count++
      if (this.count !== 1) {
        return
      }
      this.$axios({
        url: '/test/mail/settings',
        method: 'POST',
        data: data
      })
        .then((resp) => {
          this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message
          this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
        })
        .finally((resp) => {
          this.count = 0
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/config/MailTest.vue